/**
 * @param {string} name
 * @return {string|null}
 */
export function getCookie(name) {
	const matches = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
	return matches ? decodeURIComponent(matches[1]) : null;
}
